import React from "react";

export const UploaderLogicComponent = ({ children }) => {

  return (
    <div className="uplodaer-container">
        {children}
    </div>
  );
};
